<template>
	<article class="page-container bg-white salespoint-post full-width single-post">
		<header class="page-header">
			<div class="thumbnail-container">
				<img src="@/assets/imgs/kc-logo.png" :alt="`${salespoint.title} - Thumbnail`">
			</div>
			<div class="title-container">
				<h1 class="post-title" v-if="salespoint.title">{{ salespoint.title }}</h1>
				<div class="bookmarks-btn-container">
					<button type="button" :class="{ 'button hollow btn-add-to-bookmarks' :true, 'in-bookmarks': inBookmarks}" @click="toggleBookmark">
						<font-awesome-icon :icon="bookmarkIcon"	/>
					</button>
				</div>
			</div>
			<div class="meta-infos">
				<span class="category-types" v-if="salespoint.type">
					<span class="category-type" v-for="(type, key) in salespoint.type" :key="key">{{ type }}</span>
				</span>
				<span class="distance" v-if="salespoint.distance >= 0">
					<img src="@/assets/svgs/2024/icons/distance.svg" alt="distance">
					{{ (salespoint.distance/1000).toFixed(0) + $t('isAway') }}
				</span>
			</div>

			<back-button fixed />
		</header>

		<section class="page-content-container" v-if="salespoint.details" v-html="salespoint.details.content" />

		<hr class="section-divider" v-if="salespoint.details" />

		<section class="contact-infos">
			<div class="info address-info" v-if="salespoint.details && salespoint.details.address">
				<div class="button-wrapper">
					<button type="button" class="btn-info button hollow">
						<font-awesome-icon :icon="['fal', 'map-marker-alt']" />
					</button>
				</div>
				<div class="info-wrapper">
					<span class="address">{{ salespoint.details.address }}</span>
				</div>
			</div>
			<div class="info telefon-info" v-if="salespoint.details && salespoint.details.phone">
				<div class="button-wrapper">
					<button type="button" class="btn-info button hollow">
						<font-awesome-icon :icon="['fal', 'phone']" />
					</button>
				</div>
				<div class="info-wrapper">
					<a class="phone" :href="`tel://${$options.filters.normalizePhoneNumber(salespoint.details.phone)}`">{{ salespoint.details.phone }}</a>
				</div>
			</div>
			<div class="info email-info" v-if="salespoint.details && salespoint.details.email">
				<div class="button-wrapper">
					<button type="button" class="btn-info button hollow">
						<font-awesome-icon :icon="['fal', 'envelope']" />
					</button>
				</div>
				<div class="info-wrapper">
					<a class="email" target="_blank" rel="noopener nofollow" :href="`mailto:${salespoint.details.email}`">{{ salespoint.details.email }}</a>
				</div>
			</div>
			<div class="info web-info" v-if="salespoint.details && salespoint.details.homepage">
				<div class="button-wrapper">
					<button type="button" class="btn-info button hollow">
						<font-awesome-icon :icon="['fal', 'external-link']" />
					</button>
				</div>
				<div class="info-wrapper">
					<a class="weblink" target="_blank" rel="noopener nofollow" :href="`${formatUrl(salespoint.details.homepage)}`">{{ salespoint.details.homepage }}</a>
				</div>
			</div>
			<div class="info arrival-info" v-if="salespoint.details">
				<div class="button-wrapper">
					<button type="button" class="btn-info button hollow">
						<font-awesome-icon :icon="['fal', 'directions']" />
					</button>
				</div>
				<div class="info-wrapper">
					<span class="arrival" v-html="salespoint.details.arrival_info" />
				</div>
			</div>
		</section>

		<hr class="section-divider" />

		<section class="actions">
			<div class="action-container">
				<a :href="this.mapLink(salespoint.coords.lat, salespoint.coords.lng, salespoint.title)" type="button" class="button hollow btn-route"  target="_blank">
					<font-awesome-icon :icon="['fal', 'directions']" size="2x" />
				</a>
				<span class="button-text">{{ $t('buttonActions.route') }}</span>
			</div>
			<div class="action-container">
				<button type="button" class="button hollow btn-map" @click="navigateToMap">
					<font-awesome-icon :icon="['fal', 'map-marker-alt']" size="2x" />
				</button>
				<span class="button-text">{{ $t('buttonActions.map') }}</span>
			</div>
			<div class="action-container">
				<button type="button" :class="{ 'button hollow btn-add-to-bookmarks' :true, 'in-bookmarks': this.inBookmarks }" @click="toggleBookmark">
					<font-awesome-icon :icon="bookmarkIcon" size="2x" />
				</button>
				<span class="button-text">{{ $t('buttonActions.bookmarks') }}</span>
			</div>
			<div class="action-container">
				<button type="button" class="button hollow btn-share" @click="openShareReveal">
					<font-awesome-icon :icon="['fal', 'share']" size="2x" />
				</button>
				<span class="button-text">{{ $t('buttonActions.share') }}</span>
			</div>
		</section>

		<section class="buy-card">
			<a class="btn-buy-card button" data-scope="week" :href="weekCardLink" target="_blank" rel="nofollow noopener">
				<font-awesome-icon :icon="['fal', 'credit-card']" />
				<span class="button-text">{{ $t('buyCards.weekCard') }}</span>
			</a>
			<a class="btn-buy-card button" data-scope="season" :href="seasonCardLink" target="_blank" rel="nofollow noopener">
				<font-awesome-icon :icon="['fal', 'credit-card']" />
				<span class="button-text">{{ $t('buyCards.seasonCard') }}</span>
			</a>
		</section>

		<share-reveal ref="shareReveal" id="share-reveal" :key="`share-reveal-${salespoint.id}`" :entity="salespoint" :share-link="shareLink" :scrape-link="scrapeLink" v-if="salespoint && salespoint.details" v-on:close-share-reveal="closeShareReveal" />
	</article>
</template>

<script>
	import foundation from '@/mixins/foundation'
	import BackButton from '@/components/BackButton.vue'
	import ShareReveal from '@/components/ShareReveal.vue'
  import Mixins from "@/components/Mixins.vue"

	export default{
		name: 'SingleSalespointPage',
		components: {
			BackButton,
			ShareReveal
		},
		mixins: [foundation,Mixins],
		data() {
			return {
				isLoading: true
			}
		},
		metaInfo() {
			return {
				title: (this.salespoint != null? this.salespoint.title : '') + ' | ' + this.$t('buyCard') + ' | ' + 'Kärnten Card App',
				meta: [{
					property: 'og:title', content:  (this.salespoint != null? this.salespoint.title : '') + ' | ' + this.$t('buyCard') + ' | ' + 'Kärnten Card App'
				}, {
					property: 'og:site_name', content: 'Kärnten Card App'
				}, {
					property: 'og:url', content: window.location.href
				}, {
					property: 'og:image', content: "https://app.kaerntencard.at/img/kc-logo.png"
				},{
					property: 'og:description', content: ""
				}]
			}
		},
		beforeRouteEnter(to, from, next) {
			next((vm) => {
				vm.from = from.name;
			});
		},
		computed: {
			salespoint () {
				return this.$store.getters.getSalespointByID(this.$route.params.uuid)
			},
			bookmarkIcon () {
				if (this.inBookmarks) {
					return ['fas', 'heart']
				} else {
					return ['fal', 'heart']
				}
			},
			inBookmarks () {
				return this.$store.getters.getCurrentBookmarks.filter(salespoint => salespoint.id === this.salespoint.id).length === 1
			},
			shareLink () {
				return window.location.href
			},
			scrapeLink () {
				return `https://app.kaerntencard.at/admin/sharer/salespoints/${this.salespoint.id}`
			},
			weekCardLink () {
				return this.$store.state.shopLink[this.$store.state.season].weekCardLink
			},
			seasonCardLink () {
				return this.$store.state.shopLink[this.$store.state.season].seasonCardLink
			}
		},
		methods: {
			toggleBookmark (){
				if (this.inBookmarks) {
					this.removeFromBookmarks()
				} else {
					this.addToBookmarks()
				}
			},
			removeFromBookmarks () {
				this.$store.dispatch('removeBookmark', this.salespoint.id)
			},
			addToBookmarks () {
				this.$store.dispatch('createBookmark', { id: this.salespoint.id, type: 'salespoint' })
			},
			navigateToMap () {
				this.$router.push({
					name: 'map',
					params: {
						id: this.salespoint.id,
						entity: 'salespoints'
					}
				})
			},
			openShareReveal() {
				this.$refs.shareReveal.$el.classList.add('is-reveal-open')
			},
			closeShareReveal () {
				this.$refs.shareReveal.$el.classList.remove('is-reveal-open')
			}
		},
		beforeRouteUpdate(to, from, next) {
			let id = to.params.uuid
			this.$store.dispatch('fetchSalepoint', { id: id })
			.then(() => {
				next()
			})
			.catch((err) => {
				console.error(err)
				next(false)
			})
		},
		watch: {
			'$store.state.language': function() {
				this.$store.dispatch('fetchCardInfos', { lang: this.$store.state.language, season: this.$store.state.season })
					.then(() => {
						this.$store.dispatch('fetchNews', { lang: this.$store.state.language, season: this.$store.state.season })
					})
					.catch(err => console.log(err))
			},
			'$store.state.season': function () {
				this.initView()
				this.searchAndFilterCompanies()
				this.$store.dispatch('fetchCardInfos', { lang: this.$store.state.language, season: this.$store.state.season })
					.then(() => {
						this.$store.dispatch('fetchNews', { lang: this.$store.state.language, season: this.$store.state.season })
					})
					.catch(err => console.log(err))
			},
		}
	}
</script>


<style lang="scss" scoped>
.salespoint-post{
	.page-header{
		position: relative;
		.thumbnail-container{
			display: flex;
			justify-content: center;
			align-items: center;
			height: rem-calc(270px);

			img{
				width: rem-calc(200);
				height: auto;
			}
		}

		.title-container{
			@include xy-grid();
			margin-top: 1rem;
			margin-bottom: rem-calc(20);

			.post-title{
				@include xy-cell(10);
				text-align: left;
			}
			.bookmarks-btn-container{
				@include xy-cell(2);
				@include flex();
				@include flex-align(right, top);

				.btn-add-to-bookmarks{
					display: flex;
					justify-content: center;
					align-items: center;
					width: 2.5rem;
					height: 2.5rem;
					font-size: 1.25rem;
					margin: 0;
					padding: .25rem;
					border-radius: 20rem;

					svg {
						margin-top: 2px;
					}

					&.in-bookmarks {

					}
				}
			}
		}

		.meta-infos{
			@include flex();
			@include xy-gutters();
			justify-content: space-between;
			align-items: center;
			margin-bottom: rem-calc(20);

			.category-types{
				.category-type{
					@include button();
					margin: 0;
					padding: .35rem 1.25rem;
					border-radius: 20rem;
					font-weight: 600;
					line-height: 1;
					text-transform: uppercase;
					text-shadow: 0px 0px 1px rgba($dark-gray, .2);
				}
			}

			.distance{
        display: flex;
        font-size: 0.875rem;
        margin: 0 1rem;

        img {
          margin-right: 0.5rem;
          height: 18px;
          width: 18px;
        }
			}
		}
	}

	hr.section-divider{
		max-width: 100vw;
		border-bottom: 1px solid rgba($dark-gray, .1);
	}


	section.page-content-container{
		white-space: pre-wrap;
	}

	section.contact-infos{
		@include xy-gutters();
		.info{
			@include flex();
			@include flex-align(left, top);
			margin-bottom: 1rem;

			.button-wrapper{
				margin-right: 1rem;
				.btn-info{
					width: 2.5rem;
					height: 2.5rem;
					padding: 0;
					font-size: 1.25rem;
					border-radius: 50%;
					cursor: default;

				}
			}
			.info-wrapper{
				margin-top: .5rem;
			}
		}
	}

	section.actions{
		@include xy-gutters();
		@include flex();
		@include flex-align(center, middle);

		.action-container{
			text-align: center;
			&:not(:last-child){
				margin-right: 1.25rem
			}

			.button{
				display: block;
				width: 3.25rem;
				height: 3.25rem;
				padding: 0;
				margin: 0;
				margin-bottom: rem-calc(10);
				font-size: 1rem;
				border-radius: 50%;

				&:not(.btn-add-to-bookmarks):hover{
					color: $white;
					background-color: get-color(primary);
					border-color: get-color(primary);
				}

				&.btn-route{
					svg{
						margin-top: .5rem!important;
					}
				}

				&.btn-add-to-bookmarks{
					&.in-bookmarks{
						color: $white;
						background-color: get-color(primary);
					}
				}
			}
			.button-text{
				@extend .text-primary;
				display: inline-block;
			}
		}
	}

	section.buy-card{
		@include xy-grid();
		@include flex();
		@include flex-align(center, middle);

		padding-top: rem-calc(20);
		padding-bottom: rem-calc(20);

		.btn-buy-card{
			@include xy-cell(12);
			@include flex();
			@include flex-align(left, middle);
			max-width: rem-calc(450);
			padding: .95rem 2rem;
			font-size: 1.25rem;
			border-radius: 20rem;

			.button-text{
				display: inline-block;
				font-size: 1rem;
				margin-left: 1rem;
			}

			&[data-scope="week"]{
				margin-bottom: 1rem;
				color: get-color(primary);
				background-color: $white;

				&:hover,
				&:focus{
					color: scale-color(get-color(primary), $lightness: -5%);
					background-color: scale-color($white, $lightness: -5%);
				}
			}

			&[data-scope="season"]{
				margin-bottom: 0;
			}

			@include breakpoint(medium) {
				@include xy-cell(6);
				margin-bottom: 0 !important;
			}
		}
	}
}

</style>
